<template>
  <div>
    <div ref="scrollwrapper" v-if="!isEmpty(comments)" style="max-height: 500px; overflow-y: auto; overflow-x: hidden;">
      <pagination style="margin-bottom: 10px;" v-if="!isEmpty(auth) && !disabledComment && !loading_get_comments" :dataProvider="dataProvider" :clickHandler="clickHandler" :count_items="comments.length"></pagination>
      <div v-if="!disable_loading_get_comments && (loading_get_comments || loading_get_comments_refresh)">
        <spinner-loading></spinner-loading>
      </div>

      <div v-for="(comment, key) in comments" class="comment" :key="key">
        <article class="media" style="margin-bottom: 5px;">
          <figure class="media-left">
            <nuxt-link :to="{name: 'profile-username', params: {username: !isEmpty(comment.user) ? comment.user.email : ''}}">
              <p class="image is-30x30 is-circle" style="overflow: hidden;">
                <avatar :avatar_url="!isEmpty(comment.user) && !isEmpty(comment.user.media) && !isEmpty(comment.user.media.images) ? comment.user.media.images.thumb.link : null"></avatar>
              </p>
            </nuxt-link>
          </figure>
          <div class="media-content komentar-terbaru">
            <div class="content">
              <div>
                <div class="columns is-gapless" style="margin-bottom: 0;">
                  <div class="column is-narrow truncated-text">
                    <strong class="font-14 has-text-darkblue font-w-600"><nuxt-link class="has-text-darkblue" :to="{name: 'profile-username', params: {username: !isEmpty(comment.user) ? comment.user.email : ''}}">{{ detailComment(comment, 'name') }}</nuxt-link>&nbsp;</strong>
                  </div>
                  <div class="column truncated-text" :title="comment.user.universityName">
                    <span class="has-text-primary2" v-if="!isEmpty(comment.user.universityName)">
                      <small class="font-12 font-w-500"><i class="far fa-building"></i>&nbsp;{{ comment.user.universityName }}</small>
                    </span>
                  </div>
                  <div class="column has-text-left is-hidden-tablet">
                    <small class="tanggal-komentar" style="font-size: .707rem;">{{ date_humanize(comment.createdAt) }} &nbsp;</small>
                  </div>
                  <div class="column has-text-right is-hidden-mobile">
                    <small class="tanggal-komentar" style="font-size: .707rem;">{{ date_humanize(comment.createdAt) }} &nbsp;</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="media-right" v-if="(!isEmpty(auth) && comment.userId == auth.id) || isPass(null, ['user_can_delete_other_user_comment'])">
            <b-dropdown aria-role="list" position="is-bottom-left">
              <a slot="trigger" href="" class="has-text-grey" @click.prevent="">
                <b-icon icon="dots-horizontal"></b-icon>
              </a>

              <b-dropdown-item class="has-text-darkred" aria-role="listitem" @click="removeComment(comment.id)">Hapus Komentar</b-dropdown-item>
            </b-dropdown>
          </div>
        </article>

        <pre class="pre-comment font-12" v-html="comment.contentTaggables"></pre>
      </div>

      <!-- <div class="comment" v-if="!isEmpty(typers)">
        <p class="has-text-grey"><small><span v-for="(i, key) in typers" :key="key"><strong class="has-text-info"><em>{{ i.name }}</em></strong><span v-if="(key + 1) < typers.length">,</span></span> sedang mengetik...</small></p>
      </div> -->
    </div>

    <div v-if="!disabledComment" style="margin-top: 10px;">
      <article class="media" v-if="disable_loading_get_comments || !loading_get_comments && !loading_get_comments_refresh">
        <figure class="media-left is-hidden-mobile">
          <p class="image is-35x35 is-circle" style="overflow: hidden;">
            <avatar :avatar_url="!isEmpty(auth) && !isEmpty(auth.media) && !isEmpty(auth.media.images) ? auth.media.images.thumb.link : null"></avatar>
          </p>
        </figure>
        <div class="media-content">
          <div class="columns is-mobile">
            <div class="column">
              <div class="field is-grouped" style="margin-bottom: 0;">
                <p class="control is-expanded">
                  <textarea-autosize class="textarea"
                    placeholder="Tambahkan komentar..."
                    rows="1"
                    style="
                      background-color: #F7F7F7;
                      padding: 4px 5px;
                      font-size: 12px;
                    "
                    v-model="commentData.content"
                    ref="comment_col"
                    @input="onChangeContent"
                  ></textarea-autosize>
                </p>
              </div>

              <div style="position: relative;" v-if="show_user">
                <div class="box" style="padding: 0; position: absolute; width: 100%; z-index: 1;">
                  <div class="columns is-mobile is-vcentered is-fullwidth"
                    style="margin: 0;"
                    @mouseover="hover = user.id"
                    @mouseleave="hover = user.id"
                    :style="{cursor: hover ? 'pointer' : ''}"
                    @click.prevent="clickContact(user)"
                    v-for="(user, index) in users"
                    :key="index"
                    :class="{'has-background-white-bis': hover == user.id}"
                  >
                    <div class="column is-narrow" style="padding-right: 0;">
                      <figure class="image is-24x24">
                        <img v-if="!isEmpty(user.avatar)" :src="user.avatar" alt="">
                        <img v-else src="/assets/img/default-male.svg" alt="">
                      </figure>
                    </div>
                    <div class="column">
                      <p class="title has-text-dark is-5" style="font-size: 14px; font-weight: 600">{{ user.mentionUsername }}</p>
                      <p class="subtitle has-text-grey is-6" style="font-size: 13px;">{{ user.mentionName }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-narrow" style="padding-left: 0;">
              <div class="buttons" style="align-items: normal;">
                <button type="submit" class="button tooltip is-small"
                  :class="loading_reply ? 'is-loading' : ''"
                  :disabled="loading_reply"
                  data-tooltip="Berikan komentar"
                  @click.prevent="addReply"
                >
                  <span class="icon">
                    <b-icon size="is-small" icon="send"></b-icon>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { POST } from '~/consts';
import USER_MIXIN from '~/mixins/user'
import COMMENT_MIXIN from '~/mixins/comment'

export default {
  mixins: [USER_MIXIN, COMMENT_MIXIN],

  props: {
    group: {
      type: Object,
      required: true
    },
    post: {
      type: Object,
      required: true
    },
    commentsData: {
      type: Array,
      default: () => []
    },
    loadSelf: {
      type: Boolean,
      default: false
    },
    disabledComment: {
      type: Boolean,
      default: false
    },
    memberRole: {
      type: String,
      default: null
    },
    memberId: {
      type: [String, Number],
      default: null
    }
  },

  mounted() {
    const vm = this;

    if (this.loadSelf) {
      this.getComments(this.post.id, true);
    }

    // Set scoll at the bottom
    let el = this.$refs.scrollwrapper;
    if (!this.isEmpty(el)) {
      el.scrollTop = el.scrollHeight;
    }

    // this.channel = window.Echo.private(`new-post-comment-${this.post.id}`)

    // this.channel.listen('NewPostCommentEvent', function (e) {
    //   vm.setCommentsData(e.data.payload, true);
    //   vm.dataProvider.page['current'] = 1
    // })
    // .listenForWhisper('typing', (e) => {
    //   if (e.typing) {
    //     vm.typers = collect(vm.typers).push(e).unique('id').toArray();
    //   } else {
    //     vm.typers = collect(vm.typers).filter((i) => {
    //       if (i.id != e.id) {
    //         return true
    //       }

    //       return false;
    //     }).unique('id').toArray();
    //   }
    // })
  },

  watch: {
    commentsData(val) {
      this.setCommentsData(val);
    },
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
    }),
    content() {
      return this.commentData.content
    }
  },

  data() {
    let comments = collect(_.cloneDeep(this.commentsData)).sortBy('createdAt').toArray()

    return {
      show_user: false,
      hover: null,
      counter: 3,
      typing: false,
      typers: [],
      loading_reply: false,
      loading_get_comments: false,
      loading_get_comments_refresh: false,
      commentData: {
        content: ''
      },
      channel: null,
      comments,
      dataProvider: {
        page: {
          current: 1,
          limit: 10,
          total: this.post.commentCount,
          next: this.post.commentCount > comments.length ? 2 : -1
        }
      },
      mentionableUserDataProvider: {
        page: {
          current: 1,
          limit: 5
        },
        criterion: []
      },
      disable_loading_get_comments: false,
      users: []
    }
  },

  methods: {
    ...mapActions({
      getCountUnread: 'notifications/getCountUnread',
      getNotifications: 'notifications/getList',
    }),
    clickHandler() {
      this.getComments(this.post.id);
    },
    detailComment(comment, attribute) {
      const post = this.post;
      const user = comment.user;
      const account = user.activeAccount;

      // if (!this.isEmpty(this.group) && post.group.type === 'A' && !this.isEmpty(account)) {
      //   return account[attribute];
      // }

      return user[attribute];
    },
    onGetCommentsSuccess(data, refresh) {
      this.dataProvider = data.data.dataProvider

      if (refresh) {
        this.setCommentsData(data.data.data, true);
      } else {
        this.setCommentsData(data.data.data);
      }
    },
    addReply() {
      const vm = this;
      const post = this.post;

      if (!post.group.anyoneCanComment && (this.isEmpty(post.group.groupMemberRole) && this.isEmpty(this.memberRole))) {
        this.$buefy.toast.open({
          message: 'Akses anda dibatasi, gabung ke grup terlebih dahulu',
          type: 'is-danger'
        });
        return;
      }

      vm.loading_reply = true;
      this.$axios.post(POST.ADD_COMMENT(post.id), this.commentData)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.resetComment();

            vm.setCommentsData(data.data.data, true)
            vm.$emit("onReplied", data.data);
            vm.dataProvider = data.data.dataProvider

            if (post.group.type != 'U') {
              // vm.track('comment', 'add_new_comment', post.id, 'gm', this.memberId)
              this.ga_send_event(this.auth, {
                dimension8: post.group.id,
                dimension9: post.group.name,
                dimension10: post.group.type,
                dimension11: data.data.id,
                dimension12: data.data.title,
                dimension13: data.data.type,
                metric3: 1
              })
            }
          } else {
            this.$buefy.toast.open({
              message: data.applicationSystem.message,
              type: 'is-danger'
            });
          }

          vm.loading_reply = false;
        }).catch(() => {
          vm.loading_reply = false;
        });
    },
    onRemoveCommentSuccess(res) {
      this.resetComment();

      this.setCommentsData(res.data.data, true);
      this.dataProvider = res.data.dataProvider
      this.$emit("onReplied", res.data);

      toast.default(res.applicationSystem.message)
    },
    onRemoveCommentFailed(res) {
      toast.danger(res.applicationSystem.message);
    },
    resetComment() {
      this.commentData = {
        content: ''
      }
    },
    setCommentsData(comments, refresh = false) {
      const vm = this;

      if (!refresh) {
        comments = collect(vm.comments).merge(comments).toArray();
      }

      comments = collect(comments).sortBy('createdAt').toArray();

      vm.comments = comments;
    },
    getTypingWord(text) {
      let vm = this

      let textarea = this.$refs.comment_col
      let cursorPosition = textarea.$el.selectionStart
      let preText = text.substring(0, cursorPosition);
      let last_word = ''
      let index = '-1';

      if (preText.indexOf(" ") > 0) {
        let words = preText.split(" ");
        index = words.length - 1;
        last_word = words[index]; //return last word
      } else {
        last_word = preText;
        index = 0
      }

      return {index, last_word}
    },
    debounceGetMentionableUsers: _.debounce(function (refresh) {
      this.getMentionableUsers(refresh)
    }, 500),
    onChangeContent(text) {
      let vm = this
      let {last_word: word} = this.getTypingWord(text)

      let fchar = word[0]
      let search_text = word.replace('@', '')
      if (!vm.isEmpty(fchar) && fchar == '@' && !this.isEmpty(search_text)) {
        this.search_mentionable_user = search_text;
        this.debounceGetMentionableUsers(true)
        this.show_user = true
      } else {
        this.show_user = false
      }
    },
    clickContact(user) {
      let {index} = this.getTypingWord(this.commentData.content)

      let content = this.commentData.content.split(' ').map((word, key) => {
        if (key == index) {
          return `@${user.mentionUsername} `
        }

        return word
      })

      this.commentData['content'] = content.join(' ')
      Vue.nextTick(() => {
        this.show_user = false
        this.$refs.comment_col.$el.focus()
      })
    },
    onGetMentionableUsersSuccess(users) {
      this.users = users
    }
  }
}
</script>

<style>
  .VueCarousel-dot-container {
    margin: 0 !important;
  }
  .VueCarousel-dot {
    margin-top: 10px !important;
  }
</style>
